/** Document screens, as declarations.
 *
 * Purchase Orders first — it is the document with an approval chain, a
 * statutory-ish number, and commercial values, so it exercises every part
 * of the archetype at once.
 */

import type { DocumentSpec } from '@/types'

export const PURCHASE_ORDER: DocumentSpec = {
  module: 'purchase', object: 'po', docType: 'PO',
  title: 'Purchase Orders', path: 'purchase/po', idKey: 'po_id',

  listColumns: [
    { key: 'doc_no',      label: 'PO No.', width: '130px' },
    { key: 'doc_date',    label: 'Date', width: '110px' },
    { key: 'supplier_id', label: 'Supplier' },
    { key: 'project_id',  label: 'Project', width: '130px' },
    { key: 'total_value', label: 'Value', numeric: true, value: true },
  ],

  headerFields: [
    { key: 'supplier_id', label: 'Supplier', required: true },
    { key: 'doc_date',    label: 'Date', type: 'date', required: true },
    { key: 'project_id',  label: 'Project' },
    { key: 'remarks',     label: 'Remarks' },
  ],

  lineColumns: [
    { key: 'item_id', label: 'Item', edit: 'picker', lookup: 'items',
      required: true, width: '30%' },
    { key: 'uom',     label: 'UOM', edit: 'text', width: '90px' },
    { key: 'qty',     label: 'Qty', edit: 'number', numeric: true,
      required: true, width: '110px' },
    // `value: true` — a caller without purchase.po.view_values gets no rate
    // column, no input, and no amount. The server never sends them.
    { key: 'rate',    label: 'Rate', edit: 'number', numeric: true,
      value: true, width: '130px' },
  ],
}

export const DOCUMENT_SCREENS: Record<string, DocumentSpec> = {
  'purchase/po': PURCHASE_ORDER,
}
